import { render, staticRenderFns } from "./AddGaugeToDashboard.vue?vue&type=template&id=1997b430"
import script from "./AddGaugeToDashboard.vue?vue&type=script&lang=js"
export * from "./AddGaugeToDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports